// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"528":"0f16f024","839":"2c532750"}[chunkId] + ".chunk.js";
};